var _rect, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "transfer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 60,
    height: 60,
    rx: 5,
    fill: "#b0ffd0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M170.986,201.481v15.672a3.131,3.131,0,0,1-3.131,3.131H140.631a3.131,3.131,0,0,1-3.131-3.131V201.481a3.131,3.131,0,0,1,3.131-3.131h27.221A3.131,3.131,0,0,1,170.986,201.481Z",
    transform: "translate(-124.453 -179.529)",
    fill: "#b0ffd0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M166.356,198.32c-4.455,12.431-15.316,18.91-28.857,19.763-.211-.657-.149.426-.149-16.629a3.131,3.131,0,0,1,3.131-3.131Z",
    transform: "translate(-124.309 -179.502)",
    fill: "#e1ffed"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M144.417,363.477h-3.8a3.131,3.131,0,0,1-3.131-3.131v-3.8A6.927,6.927,0,0,1,144.417,363.477Z",
    transform: "translate(-124.444 -322.718)",
    fill: "#b0ffd0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M140.631,198.32h3.8a6.927,6.927,0,0,1-6.927,6.927v-3.8A3.131,3.131,0,0,1,140.631,198.32Z",
    transform: "translate(-124.453 -179.502)",
    fill: "#b0ffd0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M424.327,201.481v3.8a6.927,6.927,0,0,1-6.927-6.927h3.8A3.131,3.131,0,0,1,424.327,201.481Z",
    transform: "translate(-377.794 -179.529)",
    fill: "#b0ffd0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M424.327,356.52v3.8a3.131,3.131,0,0,1-3.131,3.131h-3.8A6.927,6.927,0,0,1,424.327,356.52Z",
    transform: "translate(-377.794 -322.69)",
    fill: "#b0ffd0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 5.196,
    cy: 5.196,
    r: 5.196,
    transform: "translate(24.593 24.592)",
    fill: "#b9dcff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M143.634,360.465a42.914,42.914,0,0,1-4.55.683,1.565,1.565,0,0,1-1.714-1.56c0-.639.009-1.583.009-3.068A6.927,6.927,0,0,1,143.634,360.465Z",
    transform: "translate(-124.335 -322.691)",
    fill: "#e1ffed"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M419.414,199.4c-.316.787-.677,1.594-1.091,2.413a6.889,6.889,0,0,1-.943-3.491h1.308a.785.785,0,0,1,.727,1.078Z",
    transform: "translate(-377.776 -179.502)",
    fill: "#e1ffed"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M269.565,264.45a28.418,28.418,0,0,1-6.832,4.85,5.2,5.2,0,1,1,6.832-4.85Z",
    transform: "translate(-234.58 -234.578)",
    fill: "#e1ffed"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M249.424,242.65a6.764,6.764,0,1,0,6.764,6.764A6.764,6.764,0,0,0,249.424,242.65Zm0,10.393a3.629,3.629,0,1,1,3.63-3.629A3.629,3.629,0,0,1,249.424,253.043Z",
    transform: "translate(-219.634 -219.625)",
    fill: "#2e58ff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M152.918,181.8H125.7a4.707,4.707,0,0,0-4.7,4.7v15.672a4.707,4.707,0,0,0,4.7,4.7h27.216a4.707,4.707,0,0,0,4.7-4.7V186.5A4.707,4.707,0,0,0,152.918,181.8Zm-28.786,4.7a1.569,1.569,0,0,1,1.568-1.568h1.993a5.382,5.382,0,0,1-3.56,3.56Zm1.567,17.236a1.569,1.569,0,0,1-1.567-1.565v-1.993a5.382,5.382,0,0,1,3.559,3.557Zm28.786-1.568a1.569,1.569,0,0,1-1.567,1.568h-1.993a5.383,5.383,0,0,1,3.559-3.56Zm0-5.219a8.519,8.519,0,0,0-6.783,6.786H130.914a8.519,8.519,0,0,0-6.783-6.781v-5.24a8.52,8.52,0,0,0,6.784-6.784H147.7a8.519,8.519,0,0,0,6.783,6.784Zm0-8.463a5.383,5.383,0,0,1-3.559-3.56h1.993a1.569,1.569,0,0,1,1.567,1.568Z",
    transform: "translate(-109.519 -164.549)",
    fill: "#26c165"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M249.424,242.65a6.764,6.764,0,1,0,6.764,6.764A6.764,6.764,0,0,0,249.424,242.65Zm0,10.393a3.629,3.629,0,1,1,3.63-3.629A3.629,3.629,0,0,1,249.424,253.043Z",
    transform: "translate(-219.634 -219.625)",
    fill: "#2e58ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M249.424,242.65a6.764,6.764,0,1,0,6.764,6.764A6.764,6.764,0,0,0,249.424,242.65Zm0,10.393a3.629,3.629,0,1,1,3.63-3.629A3.629,3.629,0,0,1,249.424,253.043Z",
    transform: "translate(-219.634 -219.625)",
    fill: "#26c165"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M355.23,62.637a1.567,1.567,0,0,1,1.567-1.564h7.481l-.459-.459a1.568,1.568,0,0,1,2.217-2.219l3.131,3.131a1.562,1.562,0,0,1,.37,1.64c-.159.445-.095.31-3.5,3.714a1.569,1.569,0,0,1-2.218-2.218l.459-.459H356.8A1.568,1.568,0,0,1,355.23,62.637Z",
    transform: "translate(-321.523 -52.439)",
    fill: "#26c165"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M135.3,475.821a1.568,1.568,0,0,1-1.568,1.567h-7.481l.459.459a1.567,1.567,0,1,1-2.217,2.217c-3.343-3.344-3.205-3.187-3.329-3.372a1.57,1.57,0,0,1-.144-1.47c.161-.389.11-.279,3.474-3.643a1.567,1.567,0,0,1,2.217,2.213l-.459.459h7.481a1.568,1.568,0,0,1,1.568,1.568Z",
    transform: "translate(-109.434 -426.442)",
    fill: "#26c165"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.7829e53c37bc1f1183b326232c991f26.svg";
export { ForwardRef as ReactComponent };